/**
 * @desc 导出toB企业订单报关报表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.customsClearance.exportCustomsClearanceExcelReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/exportCustomsClearanceExcelReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
